export const NetblitzLogo = ({ className = "", size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background circle with gradient */}
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="100%" stopColor="#002a7a" />
        </linearGradient>
        <linearGradient id="boltGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#e0eaff" />
        </linearGradient>
      </defs>
      
      {/* Main circle background */}
      <rect
        x="4"
        y="4"
        width="56"
        height="56"
        rx="14"
        fill="url(#logoGradient)"
      />
      
      {/* Lightning bolt - stylized N shape */}
      <path
        d="M38 12L22 34H30L26 52L42 28H34L38 12Z"
        fill="url(#boltGradient)"
      />
      
      {/* Accent spark */}
      <circle cx="46" cy="18" r="3" fill="#EF3B33" />
    </svg>
  );
};

export const NetblitzLogoFull = ({ className = "" }) => {
  return (
    <svg
      viewBox="0 0 200 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ height: '40px', width: 'auto' }}
    >
      {/* Icon part */}
      <defs>
        <linearGradient id="logoGradientFull" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="100%" stopColor="#002a7a" />
        </linearGradient>
      </defs>
      
      <rect
        x="2"
        y="4"
        width="40"
        height="40"
        rx="10"
        fill="url(#logoGradientFull)"
      />
      
      {/* Lightning bolt */}
      <path
        d="M28 10L16 26H22L19 38L31 21H25L28 10Z"
        fill="white"
      />
      
      {/* Accent spark */}
      <circle cx="34" cy="12" r="2" fill="#EF3B33" />
      
      {/* Text: Net */}
      <text
        x="50"
        y="33"
        fontFamily="Outfit, sans-serif"
        fontSize="26"
        fontWeight="800"
        fill="#0f172a"
      >
        Net
      </text>
      
      {/* Text: blitz */}
      <text
        x="97"
        y="33"
        fontFamily="Outfit, sans-serif"
        fontSize="26"
        fontWeight="800"
        fill="#2563EB"
      >
        blitz
      </text>
    </svg>
  );
};

export const NetblitzLogoMark = ({ className = "", size = 32 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="markGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="100%" stopColor="#002a7a" />
        </linearGradient>
      </defs>
      
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="7"
        fill="url(#markGradient)"
      />
      
      <path
        d="M19 6L11 17H15L13 26L21 14H17L19 6Z"
        fill="white"
      />
      
      <circle cx="23" cy="9" r="1.5" fill="#EF3B33" />
    </svg>
  );
};
